/**
 * ABC Dentalworks - custom JS.
 * The theme's designated extension point, loaded by layout/theme.liquid on
 * every page. Three independent blocks, each in its own IIFE.
 */

/* ---------------------------------------------------------------------------
 * 1. LATE STYLESHEET
 * abcd-announce-centre.css must beat an inline <style> block that
 * sections/announcement-bar.liquid renders in the <body>, which wins over any
 * <head> stylesheet on document order. Injecting it from here puts it last.
 * ------------------------------------------------------------------------- */
(function () {
  try {
    var ref = document.querySelector('link[href*="abcd-ebay-mobile"]');
    if (!ref || !ref.href) return;
    if (document.querySelector('link[href*="abcd-announce-centre"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = ref.href.replace('abcd-ebay-mobile', 'abcd-announce-centre');
    document.head.appendChild(link);
  } catch (e) {}
})();

/* ---------------------------------------------------------------------------
 * 2. CART BADGE - hide the chip when the cart is empty
 *
 * sections/header.liquid renders {{ cart.item_count }} into
 * .header__cart-count, so an empty cart prints a literal "0" and the blue
 * chip shows a zero on every page. CSS cannot fix it: there is no selector
 * for text content, and :empty does not match a span containing "0".
 *
 * Liquid cannot fix it either. layout/theme.liquid fires `cart:refresh` on
 * every onpageshow and theme.js answers by writing the count straight back
 * into this span, so an empty render would be repopulated a moment later.
 *
 * So: read the text, toggle a class, and let abcd-ebay-mobile.css hide it via
 *   html body .header__cart-count.is-zero { display: none !important }
 *
 * The span stays in the DOM - theme.js writes into it by reference, so
 * removing it would break the mini-cart count. The observer watches
 * childList + characterData only, NOT attributes, so toggling our own class
 * cannot re-trigger it.
 * ------------------------------------------------------------------------- */
(function () {
  function sync() {
    var n = document.querySelectorAll('.header__cart-count');
    for (var i = 0; i < n.length; i++) {
      var raw = (n[i].textContent || '').trim();
      n[i].classList.toggle('is-zero', raw === '' || raw === '0');
    }
  }

  function watch() {
    var n = document.querySelectorAll('.header__cart-count');
    if (!n.length || !window.MutationObserver) return;
    var mo = new MutationObserver(sync);
    for (var i = 0; i < n.length; i++) {
      mo.observe(n[i], { childList: true, characterData: true, subtree: true });
    }
  }

  function run() {
    try { sync(); } catch (e) {}
    try { watch(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.documentElement.addEventListener('cart:refresh', function () { setTimeout(sync, 60); });
  document.documentElement.addEventListener('product:added', function () { setTimeout(sync, 60); });
  window.addEventListener('pageshow', function () { setTimeout(sync, 60); });
})();

/* ---------------------------------------------------------------------------
 * 3. SEARCH PLACEHOLDER - shorten it on phones
 *
 * fixSearch() in snippets/abcd-ebay-fixes.liquid sets one placeholder at all
 * widths: "Search parts, brands, model numbers". That is written for the
 * desktop field. Measured in the real font at the smallest common handset:
 *
 *   viewport 360px -> .search-bar__input 225px wide,
 *                     padding 43px left + 15px right = 163px of text room
 *
 *   "Search parts, brands, model numbers"   257px   clipped
 *   "Search parts, brands, models"          201px   clipped
 *   "Search parts or model number"          208px   clipped
 *   "Search parts or models"                159px   FITS
 *
 * So the phone string is "Search parts or models" - the most merchandising
 * that fits without being cut off, with 4px to spare at 360px.
 *
 * The ARIA LABEL keeps the long descriptive string at every width. It is not
 * space-constrained, and a screen reader user should get the full sense of
 * what is searchable. Only the visible text is shortened.
 *
 * Runs after fixSearch() (which fires once on DOMContentLoaded and never
 * again), and re-applies on resize and orientation change so rotating a
 * handset into landscape restores the long string.
 * ------------------------------------------------------------------------- */
(function () {
  var LONG = 'Search parts, brands, model numbers';
  var SHORT = 'Search parts or models';
  var PHONE_MAX = 640;

  function apply() {
    var isPhone = window.innerWidth <= PHONE_MAX;
    var fields = document.querySelectorAll('.search-bar__input');
    for (var i = 0; i < fields.length; i++) {
      fields[i].setAttribute('placeholder', isPhone ? SHORT : LONG);
      if (fields[i].getAttribute('aria-label')) {
        fields[i].setAttribute('aria-label', LONG);
      }
    }
  }

  function safeApply() {
    try { apply(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeApply);
  } else {
    safeApply();
  }

  // fixSearch() runs on DOMContentLoaded too and load order is not
  // guaranteed, so re-assert once the page has settled.
  window.addEventListener('load', function () { setTimeout(safeApply, 80); });
  setTimeout(safeApply, 250);

  var t;
  function debounced() {
    clearTimeout(t);
    t = setTimeout(safeApply, 150);
  }
  window.addEventListener('resize', debounced);
  window.addEventListener('orientationchange', debounced);
})();
